import type { RouteObject } from 'react-router-dom';
import { paths } from '@/router/paths';
import { RecordSubmitPage } from './RecordSubmitPage';

export const dynamicRecordRoutes: RouteObject[] = [
  // Default lands the user on a screen telling them to pick an entity definition.
  { path: paths.dynamicRecords, element: <RecordSubmitPage /> },
  // Specific entity definition (by id).
  { path: `${paths.dynamicRecords}/:entityDefinitionId/new`, element: <RecordSubmitPage /> }
];
